import { render, staticRenderFns } from "./EditInformation.vue?vue&type=template&id=620aa6d6"
import script from "./EditInformation.vue?vue&type=script&lang=js"
export * from "./EditInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports